import React from 'react';
import PropTypes from 'prop-types';

const AccountsTableInner = (props) => {
  const { children } = props;

  return <div className="accounts-table-inner">{children}</div>;
};

AccountsTableInner.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AccountsTableInner;
